
(() => {
  const controllers = new Map();
  const init = (header) => {
    if (header.dataset.jmReady) return;
    for (const [oldHeader, oldController] of controllers) { if (!oldHeader.isConnected) { oldController.abort(); controllers.delete(oldHeader); document.body.classList.remove('jm-drawer-open'); } }
    const controller = new AbortController();
    controllers.set(header, controller);
    const listen = (target, name, handler) => target.addEventListener(name, handler, {signal:controller.signal});
    header.dataset.jmReady = 'true';
    const toggle = header.querySelector('.jm-mobile-toggle');
    const nav = header.querySelector('.jm-nav');
    const list = header.querySelector('.jm-list');
    const categories = header.querySelector('.jm-categories');
    const dropdowns = [...header.querySelectorAll('.jm-dropdown')];
    const mobile = window.matchMedia('(max-width:1024px)');
    const closeDropdowns = (except) => dropdowns.forEach(d => { if (d !== except) d.open = false; });
    const setDrawer = (open, restoreFocus = true) => {
      header.toggleAttribute('data-drawer-open', open);
      document.body.classList.toggle('jm-drawer-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (open) nav.querySelector('.jm-close').focus();
      else if (restoreFocus) toggle.focus();
    };
    const sync = () => {
      header.querySelectorAll('.jm-group').forEach(group => { group.open = !mobile.matches; });
      closeDropdowns();
      setDrawer(false, false);
      list.hidden = false;
      categories.hidden = true;
      header.querySelectorAll('[data-jm-tab]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.jmTab === 'menu')));
    };
    toggle.addEventListener('click', () => setDrawer(!header.hasAttribute('data-drawer-open')));
    header.querySelector('.jm-close').addEventListener('click', () => setDrawer(false));
    header.querySelector('.jm-backdrop').addEventListener('click', () => setDrawer(false));
    header.querySelectorAll('[data-jm-tab]').forEach(button => button.addEventListener('click', () => {
      const showCategories = button.dataset.jmTab === 'categories';
      list.hidden = showCategories;
      categories.hidden = !showCategories;
      header.querySelectorAll('[data-jm-tab]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    dropdowns.forEach(details => {
      details.querySelector(':scope > summary').addEventListener('click', event => {
        if (!mobile.matches && event.detail > 0) {
          event.preventDefault();
          closeDropdowns(details);
          details.open = true;
        }
      });
      details.addEventListener('toggle', () => { if (details.open) closeDropdowns(details); });
      let leaveTimer;
      details.parentElement.addEventListener('pointerenter', (event) => {
        if (mobile.matches || event.pointerType === 'touch') return;
        clearTimeout(leaveTimer);
        closeDropdowns(details);
        details.open = true;
      });
      details.parentElement.addEventListener('pointerleave', () => {
        if (!mobile.matches) leaveTimer = setTimeout(() => {
          if (!details.contains(document.activeElement)) details.open = false;
        }, 180);
      });
    });
    listen(document, 'click', event => { if (!header.contains(event.target) && !mobile.matches) closeDropdowns(); });
    header.addEventListener('focusout', () => setTimeout(() => { if (!header.contains(document.activeElement)) closeDropdowns(); }, 0));
    listen(document, 'keydown', event => {
      if (event.key === 'Escape') {
        const active = dropdowns.find(d => d.open);
        closeDropdowns();
        if (header.hasAttribute('data-drawer-open')) setDrawer(false);
        else if (active) active.querySelector('summary').focus();
      }
      if (event.key !== 'Tab' || !header.hasAttribute('data-drawer-open')) return;
      const focusable = [...nav.querySelectorAll('button, a[href], summary, input')].filter(e => e.getClientRects().length && !e.closest('[hidden]'));
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    listen(mobile, 'change', sync);
    sync();
  };
  document.querySelectorAll('[data-joanna-mega]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-joanna-mega]').forEach(init));
})();
